module.exports = __webpack_public_path__ + "img/property.bdf7176d.png";